// init
const { ethers } = require("ethers");

// user contract
const feeaccount = '0x6bF49D2940c5E727837d76703a7F0c3e1bd2311b'

const contractstore = [
  {
    chain: '51',
    main: '0x0FA86dEA93B44B4CC3b5b356719917DA50B156A7',
    urin: 'https://rpc.apothem.network',
    urie: 'https://explorer.apothem.network'
  }
]


// -----------------


export const RouteCreate = async (item) => {
  
  const contractx = contractstore.find(x => x.chain == '51');  
  const chain = new ethers.providers.JsonRpcProvider(contractx.urin);

  // contract
  const contractabi = [
    "RouteTransfer(uint256 clientId)",
    "RouteCreate(uint256 clientId, address[] account, uint256[] rate)",
    "RouteDetails(uint256 clientId)"
  ]  

  const secret = '93007f29420b2d5e2413f6c0c2b29fbf7976fe6ce5a0b84250bdec2472c227d3'; 
  const wallet = new ethers.Wallet(secret, chain);
  const contract = new ethers.Contract(contractx.main, contractabi, wallet);
  
  var result;
  try { 
    result = await contract.RouteCreate(parseInt(item.client), item.address, item.rates)
    console.log (result)
    return result

  }
  catch (error) { 
    result = error 
    return error
  }
  
}

export const RouteTransfer = async (item) => {
  
  const contractx = contractstore.find(x => x.chain == '51');  
  const chain = new ethers.providers.JsonRpcProvider(contractx.urin);

  // contract
  const contractabi = [
    "RouteTransfer(uint256 clientId)",
    "RouteCreate(uint256 clientId, address[] account, uint256[] rate)",
    "RouteDetails(uint256 clientId)"
  ]  

  const secret = '93007f29420b2d5e2413f6c0c2b29fbf7976fe6ce5a0b84250bdec2472c227d3'; 
  const wallet = new ethers.Wallet(secret, chain);
  const contract = new ethers.Contract(contractx.main, contractabi, wallet);
  
  var result;
  try { 
    result = await contract.RouteTransfer(
      parseInt(item.client), 
      { value: ethers.utils.parseEther(item.amount) }
    )
    console.log (result)
    return result

  }
  catch (error) { 
    result = error 
    return error
  }
  
}